import {
    Box,
    Divider,
    Typography
} from "@mui/material";
import { useState } from "react";

const PaymentSummary = ({ pricing, discount, finalAmount, plan, onApplyCoupon }) => {
    const [code, setCode] = useState("");
    const [appliedCoupon, setAppliedCoupon] = useState(null);

    const applyCoupon = () => {
        if (!code.trim()) return;

        const matchedCoupon = plan?.coupons?.find(
            (c) => c.code === code
        );

        if (!matchedCoupon) {
            alert("Invalid coupon code");
            return;
        }

        setAppliedCoupon(matchedCoupon);
        onApplyCoupon(matchedCoupon);
    };


    return (
        <Box
            sx={{
                border: "1px solid #eee",
                borderRadius: 2,
                p: 2,
                mt: 2,
                backgroundColor: "#fafafa",
            }}
        >
            {/* COUPON SECTION */}
            {/* <Typography fontWeight={600} mb={0.5}>
                Have a coupon or discount?
            </Typography>

            <Typography
                variant="body2"
                color="text.secondary"
                mb={1}
            >
                Only 1 coupon can be applied.
            </Typography>

            <Box display="flex" gap={1}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter Coupon Code"
                    value={code}
                    onChange={(e) => setCode(e.target.value.toUpperCase())}
                />
                <Button
                    variant="outlined"
                    onClick={applyCoupon}
                    sx={{ minWidth: 90 }}
                >
                    Apply
                </Button>
            </Box>

            <Divider sx={{ my: 2 }} /> */}

            {/* ORDER SUMMARY */}
            <Typography fontWeight={600} mb={1}>
                Order Summary
            </Typography>

            <Row label="Total MRP" value={`₹ ${pricing}`} />

            <Row
                label="Discount"
                value={`- ₹ ${discount}`}
                valueColor="success.main"
            />

            <Divider sx={{ my: 1.5 }} />

            <Row
                label="Amount Payable"
                value={`₹ ${finalAmount}`}
                bold
            />

        </Box>
    );
};

export default PaymentSummary;

/* 🔹 Helper Row Component */
const Row = ({ label, value, bold, valueColor }) => (
    <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={0.75}
    >
        <Typography
            fontWeight={bold ? 600 : 400}
            color="text.secondary"
        >
            {label}
        </Typography>

        <Typography
            fontWeight={bold ? 700 : 500}
            color={valueColor || "text.primary"}
        >
            {value}
        </Typography>
    </Box>
);
